import * as styles from "./FiltersFooter.style.ts";

import { useExonnHubCatalogParams } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalogParams.ts";
import { useExonnHubCatalog } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalog.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import { RangeFilter } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/RangeFilter/RangeFilter.tsx";
import { PINNED_DOWN_FILTERS } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";
import { observer } from "mobx-react-lite";

export const FiltersFooter = observer(() => {
  const listParams = useExonnHubCatalogParams();

  const { data: catalogData } = useExonnHubCatalog(listParams, {
    placeholderData: keepPreviousData,
  });

  const filters = (catalogData?.filters || []).map((filter) => {
    if (filter.type === "range") {
      return {
        ...filter,
        min: Math.floor(filter.min),
        max: Math.ceil(filter.max),
      };
    }
    return filter;
  });

  return (
    <div css={styles.actionsContainer}>
      {filters.map((filter) => {
        if (!PINNED_DOWN_FILTERS.includes(filter.name)) {
          return null;
        }
        if (filter.type === "range") {
          return <RangeFilter filter={filter} />;
        }
        return null;
      })}

      {/*        <ButtonV2
          size={"sm"}
          variant={"filled"}
          skin={"info"}
          onClick={applyFilters}
        >
          {t("applyFilters")}
        </ButtonV2>*/}
      {/*<ButtonV2*/}
      {/*  size={"sm"}*/}
      {/*  variant={"outlined"}*/}
      {/*  skin={"danger"}*/}
      {/*  onClick={handleClearFilters}*/}
      {/*>*/}
      {/*  {t("resetFilters")}*/}
      {/*</ButtonV2>*/}
    </div>
  );
});
